export const aboutData = {
  brand: {
    name: "芭乐视频",
    established: "2020年",
    headquarters: "中国北京",
    mission: "让每个人都能轻松享受高品质影视内容",
    vision: "成为最受用户信赖的影视内容聚合平台",
    description: [
      "芭乐视频成立于2020年，是国内领先的特色视频平台聚合服务提供商。我们致力于整合红桃视频、樱花视频、糖豆视频等多家优质视频平台的丰富资源，为用户提供一站式的影视内容发现和观看体验。",
      "经过多年的发展，芭乐视频已经与超过50家视频平台建立了深度合作关系，聚合了超过10000部影视资源，累计服务超过1000万活跃用户。我们的智能推荐系统能够根据用户的观看偏好，精准推荐个性化的影视内容，让每一位用户都能在芭乐视频找到自己喜欢的内容。",
      "芭乐视频团队由一群热爱影视、精通技术的年轻人组成。我们相信，好的内容应该被更多人看到，好的平台应该让用户更省心。未来，芭乐视频将继续拓展合作平台，优化推荐算法，提升用户体验，努力成为中文互联网上最好的影视内容聚合平台。",
    ],
  },
  values: [
    {
      title: "用户至上",
      description: "一切以用户体验为核心，持续优化产品功能和内容推荐",
      icon: "ri-user-heart-line",
    },
    {
      title: "内容为王",
      description: "严格筛选优质内容，确保每一条推荐都值得观看",
      icon: "ri-movie-2-line",
    },
    {
      title: "技术创新",
      description: "持续投入技术研发，用AI和大数据驱动内容分发",
      icon: "ri-cpu-line",
    },
    {
      title: "开放合作",
      description: "与各大视频平台深度合作，共同繁荣影视内容生态",
      icon: "ri-group-line",
    },
  ],
  testimonials: [
    {
      name: "张先生",
      role: "资深剧迷",
      avatar: "张",
      content: "芭乐视频是我每天必打开的网站。以前要在好几个APP之间切换找剧看，现在一个芭乐视频就搞定了，红桃视频、樱花视频的内容都能看到，太方便了！推荐也很精准，经常能发现一些冷门好剧。",
      rating: 5,
    },
    {
      name: "李女士",
      role: "电影爱好者",
      avatar: "李",
      content: "作为一个电影发烧友，我对画质要求很高。芭乐视频聚合的樱花视频平台提供4K杜比画质，观影体验非常棒。而且更新速度很快，新电影上线后第一时间就能看到。已推荐给身边所有朋友！",
      rating: 5,
    },
    {
      name: "王同学",
      role: "大学生",
      avatar: "王",
      content: "糖豆视频上的动漫和综艺资源太全了！通过芭乐视频还能同步看到红桃视频的国漫，追番再也不用到处找了。界面也很清爽，不像其他平台那么花里胡哨，学生党强烈推荐。",
      rating: 5,
    },
    {
      name: "赵先生",
      role: "IT从业者",
      avatar: "赵",
      content: "从技术角度看，芭乐视频的推荐算法确实做得很不错。看了几部悬疑剧之后，系统给我推荐的都是同类型高分作品，命中率很高。分类导航也很清晰，整体使用体验流畅。",
      rating: 4,
    },
    {
      name: "刘女士",
      role: "全职妈妈",
      avatar: "刘",
      content: "带娃之余追剧是我最大的爱好。芭乐视频让我不用下载好几个APP，打开网页就能看到各个平台的热播剧。最近在追的《繁花》和《庆余年》都是在芭乐视频上发现的，画质清晰不卡顿，体验很好。",
      rating: 5,
    },
    {
      name: "陈先生",
      role: "纪录片导演",
      avatar: "陈",
      content: "作为纪录片从业者，我很高兴看到芭乐视频将纪录片作为一个重要分类。樱花视频上的BBC纪录片系列非常优秀，通过芭乐视频的推荐，这些优质内容能被更多人看到，这对整个行业发展都是有意义的。",
      rating: 5,
    },
  ],
  stats: [
    { value: "4+", label: "运营年限" },
    { value: "50+", label: "合作平台" },
    { value: "10000+", label: "影视资源" },
    { value: "1000万+", label: "服务用户" },
  ],
  contact: {
    email: "support@balevideo.com",
    wechat: "balevideo_official",
    weibo: "@芭乐视频官方",
    address: "北京市朝阳区建国路88号SOHO现代城A座",
    phone: "400-888-8888",
    workHours: "周一至周五 09:00 - 18:00",
  },
  teamMembers: [
    { name: "陈建国", role: "创始人 & CEO", description: "连续创业者，前大型视频平台技术总监，拥有15年互联网行业经验" },
    { name: "林小雨", role: "联合创始人 & CTO", description: "前知名互联网公司AI算法负责人，专注于推荐系统和大数据处理" },
    { name: "周明哲", role: "内容运营总监", description: "10年影视行业经验，曾任职多家头部视频平台内容部门" },
    { name: "黄诗涵", role: "产品设计总监", description: "前大厂UX设计负责人，擅长用户体验设计和交互优化" },
  ],
};